import React from 'react';
import { Typography } from '@mui/material';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

interface FoodListItemRightIconProps {
}

const FoodListItemRightIcon: React.FC<FoodListItemRightIconProps> = ({ }) => {
    return (
        <Typography
            id="food-item-right-icon"
            sx={{
                transform: "translateY(-50%)",
                transition: "right .12s",
            }}
            position="absolute"
            ml="auto"
            mr="auto"
            right={0}
            top={"50%"}
            zIndex={1}>
            <KeyboardArrowRightRoundedIcon color="disabled" fontSize="large" />
        </Typography>
    )
}

export default FoodListItemRightIcon;